class ZinniaQuickBuy extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this.form = this.querySelector('form');
    this.variantInput = this.querySelector('[data-zqb-variant-input]');
    this.panel = this.querySelector('[data-zqb-panel]');
    this.openButton = this.querySelector('[data-zqb-open]');
    this.submitButton = this.querySelector('[data-zqb-submit]');
    this.optionChoices = [...this.querySelectorAll('[data-zqb-option-value]')];
    this.selectedOptions = [];

    const variantsJson = this.querySelector('[data-zqb-variants]');
    this.variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];

    this.addEventListener('click', (event) => event.stopPropagation());

    this.openButton?.addEventListener('click', () => this.open());
    this.querySelectorAll('[data-zqb-close]').forEach((button) => {
      button.addEventListener('click', () => this.closeOrDismiss());
    });

    this.optionChoices.forEach((choice) => {
      const input = choice.querySelector('input');

      if (!input) return;

      input.checked = false;
      input.removeAttribute('name');
      input.addEventListener('click', (event) => {
        if (choice.dataset.available === 'false') event.preventDefault();
      });
      input.addEventListener('change', () => {
        if (choice.dataset.available !== 'false') this.selectOption(choice);
      });
    });

    this.form?.addEventListener('submit', () => this.close());
    this.closest('.zinnia-product-card')?.addEventListener('mouseleave', () => {
      this.classList.remove('is-dismissed');
    });

    this.onKeydown = this.onKeydown.bind(this);
    document.addEventListener('keydown', this.onKeydown);
    this.updateAvailability();
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
  }

  open() {
    document.querySelectorAll('zinnia-quick-buy.is-open').forEach((quickBuy) => {
      if (quickBuy !== this) quickBuy.close();
    });

    this.classList.add('is-open');
    this.openButton?.setAttribute('aria-expanded', 'true');
    this.panel?.setAttribute('aria-modal', 'true');
    document.documentElement.classList.add('zinnia-quick-buy-lock');
    requestAnimationFrame(() => this.panel?.querySelector('button:not(:disabled)')?.focus());
  }

  close() {
    if (!this.classList.contains('is-open')) return;

    this.classList.remove('is-open');
    this.openButton?.setAttribute('aria-expanded', 'false');
    this.panel?.removeAttribute('aria-modal');
    document.documentElement.classList.remove('zinnia-quick-buy-lock');
    this.openButton?.focus({ preventScroll: true });
  }

  closeOrDismiss() {
    if (window.matchMedia('(max-width: 699px)').matches) {
      this.close();
    } else {
      this.classList.add('is-dismissed');
    }
  }

  onKeydown(event) {
    if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
  }

  selectOption(choice) {
    const position = Number(choice.dataset.optionPosition) - 1;
    this.selectedOptions[position] = choice.dataset.optionValue;

    if (!this.hasAvailableVariant(this.selectedOptions)) {
      this.selectedOptions = this.selectedOptions.map((value, index) => index === position ? value : undefined);
    }

    this.updateAvailability();
    const variant = this.findSelectedVariant();

    if (variant) {
      this.variantInput.value = variant.id;
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (this.optionCount === 1 && variant?.available) {
      this.form.requestSubmit();
      this.close();
    }
  }

  updateAvailability() {
    this.optionChoices.forEach((choice) => {
      const position = Number(choice.dataset.optionPosition) - 1;
      const candidate = [...this.selectedOptions];
      candidate[position] = choice.dataset.optionValue;
      const available = this.hasAvailableVariant(candidate);
      const selected = this.selectedOptions[position] === choice.dataset.optionValue;
      const input = choice.querySelector('input');
      const control = choice.querySelector('label, a');

      choice.dataset.available = available ? 'true' : 'false';
      input?.setAttribute('aria-disabled', available ? 'false' : 'true');
      if (input) input.checked = selected;
      control?.classList.toggle('is-disabled', !available);
      control?.setAttribute('aria-disabled', available ? 'false' : 'true');
    });

    const variant = this.findSelectedVariant();
    if (this.submitButton) this.submitButton.disabled = !variant?.available;
  }

  hasAvailableVariant(selectedOptions) {
    return this.variants.some((variant) => {
      if (!variant.available) return false;

      return selectedOptions.every((value, index) => !value || variant.options[index] === value);
    });
  }

  findSelectedVariant() {
    if (this.selectedOptions.filter(Boolean).length !== this.optionCount) return null;

    return this.variants.find((variant) => {
      return variant.options.every((value, index) => value === this.selectedOptions[index]);
    }) || null;
  }

  get optionCount() {
    return this.querySelectorAll('[data-zqb-option-group]').length;
  }
}

if (!customElements.get('zinnia-quick-buy')) {
  customElements.define('zinnia-quick-buy', ZinniaQuickBuy);
}
